export const PROJECT_DOCUMENT_ACCEPT =
  '.txt,.md,.markdown,.csv,.json,.log,.html,.htm,.xml,.yaml,.yml,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rtf,.odt,.ods,.odp,.png,.jpg,.jpeg,.webp,.svg,.ai,.sqlite,.sqlite3,.db';

/**
 * Documents only, without images. iPhones show their own menu (photo library, take photo,
 * choose files) for a file field that also takes images; the + menu has its own photo and
 * camera buttons, so its File button opens the Files app straight away.
 */
export const DOCUMENT_ONLY_ACCEPT = PROJECT_DOCUMENT_ACCEPT.split(',')
  .filter((ext) => !['.png', '.jpg', '.jpeg', '.webp', '.svg'].includes(ext))
  .join(',');

/** Whether Chat can read this file (SVG becomes an image, an Illustrator file is read as PDF). */
export function isSupportedAttachment(filename: string): boolean {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  return PROJECT_DOCUMENT_ACCEPT.split(',').includes(`.${ext}`);
}

export function isSqliteFilename(filename: string): boolean {
  const ext = filename.split('.').pop()?.toLowerCase();
  return ext === 'sqlite' || ext === 'sqlite3' || ext === 'db';
}

/** Pictures that can be shown as a thumbnail (an Illustrator file is not one). */
export function isImageFilename(filename: string): boolean {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  return ext === 'png' || ext === 'jpg' || ext === 'jpeg' || ext === 'webp' || ext === 'svg';
}
